interface MediaBlogIconProps {
  fill?: string;
  width?: number;
  height?: number;
}

const MediaBlogIcon = ({ fill = "white", width = 14, height = 16 }: MediaBlogIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M2 1C1.44687 1 1 1.44687 1 2V14C1 14.5531 1.44687 15 2 15H12C12.5531 15 13 14.5531 13 14V2C13 1.44687 12.5531 1 12 1H2ZM0 2C0 0.896875 0.896875 0 2 0H12C13.1031 0 14 0.896875 14 2V14C14 15.1031 13.1031 16 12 16H2C0.896875 16 0 15.1031 0 14V2ZM3.5 4.5H10.5C10.775 4.5 11 4.725 11 5C11 5.275 10.775 5.5 10.5 5.5H3.5C3.225 5.5 3 5.275 3 5C3 4.725 3.225 4.5 3.5 4.5ZM3.5 7.5H10.5C10.775 7.5 11 7.725 11 8C11 8.275 10.775 8.5 10.5 8.5H3.5C3.225 8.5 3 8.275 3 8C3 7.725 3.225 7.5 3.5 7.5ZM3.5 10.5H5.5C5.775 10.5 6 10.725 6 11C6 11.275 5.775 11.5 5.5 11.5H3.5C3.225 11.5 3 11.275 3 11C3 10.725 3.225 10.5 3.5 10.5Z"
      fill={fill}
    />
  </svg>
);

export default MediaBlogIcon;
